function handleScrollSizes(e) {
  e.preventDefault()
  const arrowBtn = e.target;
  if (!arrowBtn?.classList.contains('arrow-btn')) {
    return;
  }
  const sizesPopupEl = arrowBtn.closest('.boa-sizes-sidebar');
  const sizesWrapEl = sizesPopupEl?.querySelector('.product-item-sizes-wrap');
  if (!sizesWrapEl) {
    return;
  }
  let { sizesAmount, currentPage } = sizesPopupEl.dataset;
  const maxPagesNum = calculateMaxNumOfPages(sizesAmount);
  currentPage = Number(currentPage);
  const itemHeight = sizesWrapEl?.children[0]?.offsetHeight ?? 0;
  const isArrowUp = arrowBtn.classList.contains('arrow-btn-up');

  if ((isArrowUp && currentPage <= 0) || (!isArrowUp && currentPage >= maxPagesNum)) {
    return;
  }
  currentPage += isArrowUp ? -1 : 1;
  sizesPopupEl.dataset.currentPage = currentPage;
  const amountToMove = calculateItemsToShow(sizesAmount, currentPage);

  const finalAmount = isArrowUp ? amountToMove * itemHeight : amountToMove * itemHeight + 2;
  sizesWrapEl.style.transform = `translateY(-${finalAmount}px)`;
  const arrowBtns = sizesPopupEl.querySelectorAll('.arrow-btn')
  toggleArrowBtns(arrowBtns, currentPage, maxPagesNum)
}

function calculateItemsToShow(itemsTotal, nextPage) {
  return nextPage === 1 ? 0 : Math.min(itemsTotal, nextPage * 5) - 6;
}

function toggleArrowBtns([upBtn, downBtn], currentPage, maxPagesNum) {
  upBtn.classList.toggle('hidden-arrow', currentPage === 1);
  downBtn.classList.toggle('hidden-arrow', currentPage === maxPagesNum);
}

function calculateMaxNumOfPages(sizesNum) {
  const itemsPerPage = 6;
  if (sizesNum <= itemsPerPage) {
    return 1;
  }
  return Math.ceil((sizesNum - itemsPerPage) / 4) + 1;
}

document.addEventListener('DOMContentLoaded', initViewportSyncWithObserver);

function initViewportSyncWithObserver() {
  const IS_MOBILE = window.innerWidth < 769;
  if (!IS_MOBILE) {
    return;
  }
  
  setupViewportSync();
  
  const productGrid = document.querySelector('.filters-adjacent.collection-listing');
  if(!productGrid) {
    return;
  }
  
  const observer = new MutationObserver(() => {
    setupViewportSync();
  });
  
  observer.observe(productGrid, { 
    childList: true,
    subtree: true 
  });
}

function setupViewportSync() {
  const allBlocks = Array.from(document.querySelectorAll('.product-block'));
  
  // Remove any existing scroll event listeners
  window.removeEventListener('scroll', handleScroll);  
  window.addEventListener('scroll', handleScroll);
  
  handleScroll();
  
  function handleScroll() {
    const blocksInSameRow = {};
    
    allBlocks.forEach(block => {
      const rect = block.getBoundingClientRect();
      const rowKey = Math.round(rect.bottom);
            
      if (!blocksInSameRow[rowKey]) {
        blocksInSameRow[rowKey] = [];
      }
      blocksInSameRow[rowKey].push(block);
    });
    
    Object.values(blocksInSameRow).forEach(rowBlocks => {
      // Check if any block in this row is in view
      const isRowInView = rowBlocks.some(block => {
        const rect = block.getBoundingClientRect();
  
        return rect.top >= 0 && 
               rect.left >= 0 && 
               rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
               rect.right <= (window.innerWidth || document.documentElement.clientWidth);
      });
      
      rowBlocks.forEach(block => {
        const sidebar = block.querySelector('.boa-sizes-sidebar');
        if (sidebar) {
          if (isRowInView) {
            sidebar.classList.add('show');
          } else {
            sidebar.classList.remove('show');
          }
        }
      });
    });
  }
}
